export const FORM_FIELD_NAMES = {
    AFFILIATE_IDS : "affiliateIds",
}